import createModel from '../lib/create_model';

const AssignedTaskReplied = createModel({
  modelName: 'AssignedTaskReplied',

  properties: {
    itemId: String,
    customerId: String,
    taskId: String,
  },
});

export default AssignedTaskReplied;
